module.exports = "images/purple.abd89a104dbbb4e1e71fa79b9ed4e03f.png";